import axios from '../Backend';

export const logoutReq = async () => {
    try {
        await axios.post('/users/logout', {})
    } catch (e) {
        console.log('dispatch logout fail')
        console.log(JSON.stringify(e))
    }

}

export const loginReq = async (email, password, reCaptchaValue) => {

    try {
        const dataTosend = {
            email: email,
            password: password,
            reCaptchaValue
        };
        const resData = await axios.post('/users/login', dataTosend);
        const data = resData.data;
        return data
    }
    catch (e) {
        if (e.response?.data) {
            throw new Error(e.response?.data?.message ? e.response.data.message : 'Unable to connect, please contact system administrator.') // e.response.data
        }
        throw new Error('Server offline')
        // return 'Server offline'
    }

}

export const agreementAcception = async (email, password, isTermOfUseAccepted, isPrivacyPolicyAccepted) => {
    try {
        // debugger;
        const dataTosend = {
            email: email,
            password: password,
            isTermOfUseAccepted,
            isPrivacyPolicyAccepted
        };
        const resData = await axios.patch('/api/v2/users/agreement', dataTosend);
        const data = resData.data?.data?.data;
        return data
    }
    catch (e) {
        if (e.response?.data) {
            throw new Error(e.response?.data?.message ? e.response.data.message : 'Unable to connect, please contact system administrator.') // e.response.data
        }
        throw new Error('Server offline')
    }
}

export const logoutAllAgents = async () => {
    try {
        const resData = await axios.post('/users/logoutAll', {});
        const data = resData.data;
        return data
    }
    catch (e) {
        if (e.response && e.response.data) {
            console.log(e.response.data)
        }
        return false
    }
}

export const disconnectSpecificAgent = async (agentName) => {
    try {
        const res = await axios.post('/users/disconnectAgent/' + agentName, {});
        const data = res.data
        return data
    }
    catch (e) {
        if (e.response && e.response.data) {
            console.log(e.response.data)
            return e.response.data
        }
        return 'Server offline'
    }

}